import React from 'react';
import { Link } from 'react-router-dom';
import { cx } from '@emotion/css';
import { Card } from '@branchjs/neo-components';
import FullScreenWrapperWithBranchLogo from '../FullScreenWrapperWithBranchLogo';
import { ImageService } from '../../../main/services/ImageService/ImageService';
import { useStyles } from './ScreenVerificationEmailSent.styles';

const IMAGE_EMAIL_SENT_FILE_LOCATION = '/static/images/loggedout/img_email_sent.svg';

export const ScreenVerificationEmailSent = ({ userEmailAddress }: { userEmailAddress: string }) => {
  const {
    card,
    cardContent,
    cardTitle,
    image,
    verifyEmailTextBlock,
    mainText,
    emailInBold,
    checkSpamTextBlock,
    linkColor,
    footer,
  } = useStyles();
  return (
    <FullScreenWrapperWithBranchLogo>
      <Card className={card}>
        <div className={cardContent}>
          <div className={cardTitle} data-testid="verify-email--header-title">
            Verification Email sent!
          </div>
          <img
            className={image}
            data-testid="verify-email--header-image"
            src={ImageService.getImageUrl(IMAGE_EMAIL_SENT_FILE_LOCATION)}
          />
          <p className={cx(mainText, verifyEmailTextBlock)}>
            Before you start using Branch, we need you to verify your email address. Use the link in the email sent to
            <span className={cx(mainText, emailInBold)} data-testid="verify-email--user-email">
              {' '}
              {`${userEmailAddress}`}{' '}
            </span>
            to verify your account.
          </p>
          <div className={cx(mainText, checkSpamTextBlock)}>
            Didn't get the email? Check your spam folder or
            <Link className={linkColor} to="/resend-verification-email" data-testid="verify-email--link-resend">
              {' '}
              resend verification{' '}
            </Link>
            <span>email.</span>
          </div>
          <div className={cx(mainText, footer)}>
            Incorrect email?{' '}
            <Link className={linkColor} to="/" data-testid="verify-email--link-signup">
              Sign up with a different account
            </Link>
          </div>
        </div>
      </Card>
    </FullScreenWrapperWithBranchLogo>
  );
};
